import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { DateRange } from 'react-date-range';
import { format } from 'date-fns';
import calendarimg from "../assets/bx_bx-calendar.png";
import 'react-date-range/dist/styles.css'; // Main style
import 'react-date-range/dist/theme/default.css'; // Theme

import './BillPayment 2.css';

function BillPayment() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [data, setData] = useState({
    processingDate: '12th November 2024',
    travellers: 4,
    governmentFee: 189304,
    platformFee: 189304,
    totalAmount: 378608,
  });

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    }
  ]);
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch('/api/visa-details');
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();
        setData(result);
        setError(null);
      } catch (err) {
        console.error('Error fetching visa details:', err);
        setError('Failed to load visa details');
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleApplyNow = () => {
    navigate("/VisaApp");
  };

  const updateTravellers = (increment) => {
    const newCount = increment ? data.travellers + 1 : Math.max(1, data.travellers - 1);
    const newGovFee = (data.governmentFee / data.travellers) * newCount;
    const newPlatformFee = (data.platformFee / data.travellers) * newCount;

    setData({
      ...data,
      travellers: newCount,
      governmentFee: newGovFee,
      platformFee: newPlatformFee,
      totalAmount: newGovFee + newPlatformFee,
    });
  };

  const formatIndianCurrency = (amount) => {
    return '₹' + Math.round(amount).toLocaleString('en-IN');
  };

  return (
    <div className="bill-payment-container">
      <div className="processing-date-container">
        <div className="processing-date-label">Estimated Visa Processing Date</div>
        <div className="processing-date-value">{data.processingDate}</div>
      </div>

      <div style={{ padding: '15px' }}>
        <div className="travellers-container">
          

          {/* Date Range Picker */}
          <div className="traveller-counter">
            <div className="bill-date-range-input" >
              {`${format(dateRange[0].startDate, 'dd/MM/yyyy')} - ${format(dateRange[0].endDate, 'dd/MM/yyyy')}`}
            </div>

            <div className='col-3 d-flex justify-center items-center' style={{cursor:'pointer',justifyContent:'center'}} onClick={() => setShowCalendar(prev => !prev)}>
              <div>
                <img style={{width:'20px'}} src = {calendarimg}></img>
              </div>
            </div>
            {showCalendar && (
            
              <div className="calendar-popup">
                <DateRange
                  editableDateInputs={true}
                  onChange={item => setDateRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={dateRange}
                />
              </div>
            )}
          </div>

          <div className="traveller-counter ">
            <div className="traveller-label">Total Travellers</div>
            <div className='travel-bill-count col-3 d-flex justify-content-between items-center' style={{ display: 'flex', flexDirection: 'row' }}>
              <div className="counter-button-increment" onClick={() => updateTravellers(true)}>+</div>
              <div className="traveller-count">{String(data.travellers).padStart(2, '0')}</div>
              <div className="counter-button-decrement" onClick={() => updateTravellers(false)}>−</div>
            </div>
          </div>
        </div>

        <div className="fee-details-container">
          <div className="fee-row">
            <div className="fee-label">Government Fee</div>
            <div className="fee-amount">{formatIndianCurrency(data.governmentFee)}</div>
          </div>
          <div className="fee-row">
            <div className="fee-label">Platform Fee</div>
            <div className="fee-amount">{formatIndianCurrency(data.platformFee)}</div>
          </div>
          <div className="fee-row-total">
            <div className="fee-label">Total Amount</div>
            <div className="fee-amount">{formatIndianCurrency(data.totalAmount)}</div>
          </div>
        </div>

        <button onClick={handleApplyNow} className="start-application-button">
          Start Application
        </button>
      </div>
    </div>
  );
}

export default BillPayment;
